import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import GroupSharpIcon from '@material-ui/icons/GroupSharp';

const dummyFunc = () => {
  return;
};

export const backArrow = (onClickFunc) => {
  return {
    noBackgroundIcon: true,
    icon: (
      <ArrowBackIosIcon
        style={{ fill: '#fff', cursor: 'pointer' }}
        onClick={onClickFunc ? onClickFunc : dummyFunc}
      />
    ),
  };
};

export const groupIcon = (onClickFunc) => {
  return {
    noBackgroundIcon: false,
    icon: (
      <GroupSharpIcon
        style={{ fill: '#fff' }}
        onClick={onClickFunc ? onClickFunc : dummyFunc}
      />
    ),
  };
};
